<template>
  <Modal
    :show="show"
    width="366"
    cancel-text=""
    action-text=""
    @close="$emit('close')"
  >
    <template #title>
      <span class="text-h2">{{ title }}</span>
    </template>
    <template #content>
      <p class="text-body-1 text-textDarkest mb-0">
        <template v-if="openedAsArchived">
          Unarchiving <span class="font-weight-bold">{{ name }}</span> will move this
          {{ detailedText }} back to your active list.
        </template>
        <template v-else>
          Archiving <span class="font-weight-bold">{{ name }}</span> will move this
          {{ detailedText }} out of your active list. You can unarchive it any time
          by setting Status to Inactive.
        </template>
      </p>
    </template>
    <template #actions>
      <DpplNewButton
        class="archive-modal-action text-button-1"
        :variant="openedAsArchived ? 'flat' : 'outlined'"
        :color="openedAsArchived ? 'primary' : 'error'"
        :loading="loading"
        @click="$emit('confirm')"
      >
        {{ openedAsArchived ? 'Unarchive' : 'Archive' }}
      </DpplNewButton>
    </template>
  </Modal>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import Modal from '@/components/shared/Modal.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  name: { type: String, default: '' },
  isArchived: { type: Boolean, default: false },
  documentType: { type: String, default: 'Job Profile' },
  detailedText: { type: String, default: 'job profile' },
  loading: { type: Boolean, default: false },
});

defineEmits(['close', 'confirm']);

// Keep the mode from when the window opened, so it does not change while it closes.
const openedAsArchived = ref(props.isArchived);

watch(() => props.show, (isShown) => {
  if (isShown) openedAsArchived.value = props.isArchived;
}, { immediate: true });

const title = computed(() => (
  openedAsArchived.value ? `Unarchive ${props.documentType}` : `Archive ${props.documentType}`
));
</script>

<style scoped lang="less">
.archive-modal-action {
  margin-top: 34px;
  width: 150px;
  height: 40px !important;
  min-height: 40px !important;
}
</style>
